import { render, staticRenderFns } from "./MuonitusPohjat.vue?vue&type=template&id=524fcb8e"
import script from "./MuonitusPohjat.vue?vue&type=script&lang=js"
export * from "./MuonitusPohjat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports